import { useCallback } from "react";
import { useApplicationModals } from "app/common/hooks";
import { useBarcodeScanner } from "app/context/BarcodeScannerContext";
import { cleanBarcode } from "app/common/cleanBarcode";
import { useToast } from "app/components/atoms/toast/toast";
import { Badge } from "app/components/atoms/badge";
import { Button } from "app/components/atoms/button";
import Table from "app/components/atoms/table";
import { InputMolecule } from "app/components/molecules/form";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import { ModalMolecule } from "app/components/molecules/modal";
import api, { productCode } from "app/integration/api";
import { useCollector, useUpdateForm } from "app/integration/common/hooks";
import { Formik, getIn } from "formik";
import { DateTime } from "luxon";
import { useEffect, useState, useRef } from "react";
import * as Yup from "yup";
import AppModals from ".";
import Resizer from "react-image-file-resizer";
import { ErrorMessage } from "app/components/atoms/form";
import { CameraIcon, PhotoIcon, XMarkIcon, CheckIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { Html5QrcodeScanner } from "html5-qrcode";
import "app/styles/qrscanner.css";

function CreateDeliveryPackingModal({ onSuccess = () => { } }) {
  const [isLoading, setIsLoading] = useState(false);
  const formPacking = useRef(null);

  const { showStates, closeModal, getPayloads } = useApplicationModals();
  const payloads = getPayloads("deliveryOrder.packing");
  const { showToast } = useToast();

  // Add these state variables at the top of the component with other states
  const [cameraMode, setCameraMode] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [cameraError, setCameraError] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  // Add this ref near other refs
  const videoRef = useRef(null);
  const [photoUsed, setPhotoUsed] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleClose = () => {
    closeModal("deliveryOrder.packing");
    onSuccess();
  };
  const handleSuccess = () => {
    closeModal("deliveryOrder.packing");
    onSuccess();
  };

  const now = DateTime.now();
  const dt = now.toISODate();
  const time = now.toLocaleString(DateTime.TIME_24_SIMPLE);

  var isError = false;
  const { openModal, setPayloads } = useApplicationModals();

  const {
    initialValues,
    setInitialValues,
    validationSchema,
    onSubmit,
    setFieldValue,
  } = useUpdateForm({
    initialValues: {
      id: null,
      code: "",
      status: 3,
      file: null,
      image_date: "",
      packing_picture: null,
      resi_number: "",
      items: [],
    },
    validationSchema: Yup.object().shape({
      name: Yup.string(),
      // file: Yup.mixed().required("Harap upload foto hasil packing terlebih dahulu."),
      status: Yup.number(),
      file: Yup.mixed().when("status", (status, schema) => {
        if (status == 3) {
          return schema.required(
            "Harap upload foto hasil packing terlebih dahulu."
          );
        }
        return schema.notRequired();
      }),
      resi_number: Yup.string().when("status", (status, schema) => {
        if (status == 4) {
          return schema.required("Nomor Resi harus diisi.");
        }
        return schema;
      }),
      items: Yup.array()
        .of(
          Yup.object().shape({
            status_packing: Yup.boolean().required("Status Packing harus diisi").oneOf([true], "Produk belum terpacking."),
          })
        )
    }),
    onSubmit: async (values) => {
      try {
        if (values.status == 3) {
          await api.deliveryOrder.update({
            id: values.id,
            status: values.status,
            packing_picture: values.file,
            image_date: values.image_date,
            items: values.items.map(item => ({
              product_code_id: item.id,
              status_product_code: item.status_packing,
              sales_order_id: payloads?.sales_order_id,
              sales_channel_id: payloads?.SalesOrder?.sales_channel_id
            }))
          });
        } else if (values.status == 4) {
          await api.deliveryOrder.update({
            id: values.id,
            status: values.status,
            resi_number: values.resi_number,
            items: values.items.map(item => ({
              product_code_id: item.id,
              status_product_code: item.status_packing,
              sales_order_id: payloads?.sales_order_id,
              sales_channel_id: payloads?.SalesOrder?.sales_channel_id
            }))
          });
        }

        // Reset file ketika sukses
        values.file = null;

        isError = false;
      } catch (error) {
        setPayloads("errorMessage.view", {
          title: "Create Packing Order",
          message: error?.response?.data?.message
            ? error?.response?.data?.message
            : "Server Error",
        });
        isError = true;
        openModal("errorMessage.view");
      }
    },
    onSuccess: () => {
      // Reset initial values: file
      setInitialValues({
        ...initialValues,
        file: null,
      });

      if (!isError) {
        handleSuccess();
      }
    },
  });

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        600,
        600,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const fileChangeHandler = async (e, index) => {
    let beforeResize = e.target.files[0];
    // Create preview URL
    const imageUrl = URL.createObjectURL(beforeResize);
    setUploadedImage(imageUrl);
    console.log("before resize file: ", beforeResize);
    let imageResize = await resizeFile(beforeResize);

    console.log("after resize: ", imageResize);

    let fileType = imageResize.type;
    let fileName = imageResize.name;

    if (
      fileType.search(/jpeg|jpg|png/gi) >= 0 ||
      fileName.search(/.rar/gi) >= 0
    ) {
      console.log(
        "file ini di perbolehkan untuk di upload",
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi),
        fileName.search(/.rar/gi)
      );
      // const uploaded = await api.uploadImage.product({ image: imageResize });

      setInitialValues({
        ...initialValues,
        file: imageResize,
        image_date: beforeResize.lastModified,
      });
    } else {
      console.log(
        "file tidak dapat di upload.",
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi),
        fileName.search(/.rar/gi)
      );
      setUploadedImage(null);
      alert(`Jenis File ${fileType} tidak dapat di upload`);
    }
  };

  const [productVariants, setProductVariants] = useState();
  const [qrCode, setQrCode] = useState("");
  const scanBarcodeInputRef = useRef(null);
  const [showQrScanner, setShowQrScanner] = useState(false);
  const qrScannerRef = useRef(null);
  const scanQueueRef = useRef(Promise.resolve());

  useEffect(() => {
    if (!showStates["deliveryOrder.packing"] || !scanBarcodeInputRef.current) return;

    const focusInput = () => {
      try {
        if (scanBarcodeInputRef?.current) {
          scanBarcodeInputRef.current.focus();
          if (typeof scanBarcodeInputRef.current.select === 'function') {
            scanBarcodeInputRef.current.select();
          }
        }
      } catch (error) {
        console.error('Error focusing input:', error);
      }
    };

    // Track input activity
    let activityTimer;
    const resetActivityTimer = () => {
      clearTimeout(activityTimer);
      activityTimer = setTimeout(focusInput, 10000); // 10 seconds of inactivity
    };

    // Initial focus attempts only when modal opens
    const focusTimers = [
      setTimeout(focusInput, 100),    // Quick initial focus
      setTimeout(focusInput, 1000),   // Secondary focus in case first one fails
      setTimeout(focusInput, 3000)    // Final attempt after 3 seconds
    ];

    // Handle keyboard activity
    const handleKeyDown = () => {
      resetActivityTimer();
    };

    // Handle mouse activity
    const handleMouseMove = () => {
      resetActivityTimer();
    };

    // Add event listeners
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousemove', handleMouseMove);

    // Initial setup
    resetActivityTimer();

    // Cleanup
    return () => {
      focusTimers.forEach(clearTimeout);
      clearTimeout(activityTimer);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [showStates["deliveryOrder.packing"]]);

  useEffect(() => {
    // Focus the input when the component mounts
    if (scanBarcodeInputRef.current) {
      const focusInput = () => {
        try {
          if (scanBarcodeInputRef?.current) {
            scanBarcodeInputRef.current.focus();
            if (typeof scanBarcodeInputRef.current.select === 'function') {
              scanBarcodeInputRef.current.select();
            }
          }
        } catch (error) {
          console.error('Error focusing input:', error);
        }
      };

      // Track input activity
      let activityTimer;
      const resetActivityTimer = () => {
        clearTimeout(activityTimer);
        activityTimer = setTimeout(focusInput, 10000); // 10 seconds of inactivity
      };

      // Multiple focus attempts
      const focusTimers = [
        setTimeout(focusInput, 5000)
      ];

      // Global click listener to maintain focus
      const handleGlobalClick = (e) => {
        if (
          scanBarcodeInputRef.current &&
          !scanBarcodeInputRef.current.contains(e.target)
        ) {
          // focusInput();
          resetActivityTimer();
        }
      };

      // Handle any input activity
      const handleInputActivity = () => {
        resetActivityTimer();
      };

      // Add event listeners
      document.addEventListener('click', handleGlobalClick);
      document.addEventListener('keydown', handleInputActivity);

      // Initial setup
      resetActivityTimer();

      // Cleanup
      return () => {
        focusTimers.forEach(clearTimeout);
        clearTimeout(activityTimer);
        document.removeEventListener('click', handleGlobalClick);
        document.removeEventListener('keydown', handleInputActivity);
      };
    }
  }, [showStates["deliveryOrder.packing"]]);

  // QR Scanner effect
  useEffect(() => {
    // Initialize QR scanner when camera mode is enabled
    if (showQrScanner && showStates["deliveryOrder.packing"]) {
      // Clean up any existing scanner
      if (qrScannerRef.current) {
        qrScannerRef.current.clear();
      }

      // Create new scanner
      const qrScanner = new Html5QrcodeScanner(
        "html5-qr-code-scanner",
        { fps: 10, qrbox: { width: 250, height: 250 } },
        /* verbose= */ false
      );

      qrScanner.render((decodedText) => {
        // Success callback
        // Clean up the scanned text - remove %22 (URL-encoded double quotes) and actual quotes
        const cleanedText = decodedText.replace(/%22/g, "").replace(/"/g, "");
        console.log(`QR Code detected: ${cleanedText}`);

        // Set the QR code and close the scanner
        setQrCode(cleanedText);
        setShowQrScanner(false);

        // Process the scanned code with the queued handler
        setTimeout(async () => {
          if (scanBarcodeInputRef.current) {
            scanBarcodeInputRef.current.focus();
          }
          await enqueueBarcodeScan(cleanedText);
          setQrCode("");
        }, 100);

      }, (errorMessage) => {
        // Error callback
        console.error(`QR Code scanning error: ${errorMessage}`);
      });

      qrScannerRef.current = qrScanner;

      // Clean up on unmount
      return () => {
        if (qrScannerRef.current) {
          qrScannerRef.current.clear();
          qrScannerRef.current = null;
        }
      };
    }
  }, [showQrScanner, showStates]);

  /**
   * Memperbarui status packing sebuah baris OrderItem pada backend.
   *
   * @param {Object} e - Event atau objek berformat { target: { checked: boolean } }.
   * @param {number|string} id - ID dari OrderItem yang diperbarui.
   * @returns {Promise<boolean>} True jika berhasil diperbarui di backend, false jika gagal.
   * @sideEffects Mengirim request ke API orderItem.orderPackingUpdate dan mengatur state loading.
   */
  const updateStatusPacking = async (e, id) => {
    try {
      setIsLoading(true);
      const isChecked = e?.target?.checked ? true : false;
      const res = await api.orderItem.orderPackingUpdate(id, isChecked);

      if (res?.message === "Data update success" || res?.status === "success") {
        setIsLoading(false);
        return true;
      } else {
        throw new Error("Gagal update status packing");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Gagal update status packing:", error);
      showToast("Gagal memperbarui status packing item", "error");
      return false;
    }
  };

  /**
   * Memperbarui status unit fisik ProductCode di backend (misalnya beralih antara "packing" dan "warehouse").
   *
   * @param {Object} data - Data pembaruan { id, status_packing, scan_packing_date, sales_order_id, sales_channel_id }.
   * @returns {Promise<boolean>} True jika berhasil diperbarui di backend, false jika gagal.
   * @sideEffects Mengirim request ke API productCode.update dan mengatur state loading.
   */
  const updateProductCode = async (data) => {
    if (!data?.id) return false;
    try {
      setIsLoading(true);
      const res = await api.productCode.update(data.id, {
        status: data.status_packing ? "packing" : "warehouse",
        scan_packing_date: data.scan_packing_date,
        sales_order_id: data.sales_order_id,
        sales_channel_id: data.sales_channel_id,
      });

      if (res?.message === "Data update success" || res?.status === "success") {
        setIsLoading(false);
        return true;
      } else {
        throw new Error("Gagal update product code");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Gagal update product code:", error);
      showToast("Gagal memperbarui data product code", "error");
      return false;
    }
  };

  /**
   * Memeriksa apakah seluruh item pada pesanan telah berhasil di-pack.
   * Jika seluruh item sudah ter-packing, otomatis memperbarui status packing di payloads OrderItems.
   *
   * @param {Array} [itemsToCheck] - Daftar item terbaru yang diperiksa status packingnya.
   * @returns {Promise<void>}
   * @sideEffects Mengupdate status packing seluruh OrderItems via API jika semua item sudah selesai di-pack.
   */
  const checkAllItemPacked = async (itemsToCheck) => {
    if (!payloads?.OrderItems || payloads.OrderItems.length === 0) return;

    const items = itemsToCheck || formPacking.current?.values?.items || initialValues?.items || [];
    const isAllPacked = items.length > 0 && items.every((item) => item?.status_packing);

    const updatePromises = payloads.OrderItems.map(async (element) => {
      try {
        await updateStatusPacking(
          { target: { checked: isAllPacked } },
          element?.id
        );
      } catch (error) {
        console.error(`Error updating status for item ${element?.id}:`, error);
      }
    });

    await Promise.all(updatePromises);
  };

  /**
   * Membatalkan status packing pada sebuah item pesanan dan mengembalikan unit ke status gudang.
   * Mereset status_packing, product_code_id, dan barcode_unique pada Formik items.
   *
   * @param {number|string} id - ID item yang dibatalkan status packingnya.
   * @param {Object} formikContext - Context Formik { setFieldValue, values }.
   * @returns {Promise<void>}
   * @sideEffects Mengembalikan status productCode ke warehouse dan memperbarui formik items.
   */
  const cancelPacking = async (id, { setFieldValue, values }) => {
    const currentItems = values?.items || initialValues?.items || [];
    const updatedItems = currentItems.map((item) => ({ ...item }));
    const item = updatedItems.find((el) => el.id === id && el.status_packing);

    if (item) {
      if (item?.product_code_id) {
        await updateProductCode({
          id: item.product_code_id,
          status_packing: false,
          scan_packing_date: null,
          sales_order_id: null,
        });
      }

      await updateStatusPacking({ target: { checked: false } }, id);

      for (let element of updatedItems) {
        if (element?.id === id && element?.status_packing) {
          element.status_packing = false;
          element.product_code_id = null;
          element.barcode_unique = null;
          break;
        }
      }
    }

    setFieldValue("items", updatedItems);
    setInitialValues((prev) => ({ ...prev, items: updatedItems }));
    checkAllItemPacked(updatedItems);
  };

  /**
   * Menangani pemrosesan pemindaian barcode pada modal Packing Order.
   * Mencari kecocokan barcode unit unik (ProductCode) atau barcode varian/SKU produk.
   * Menandai item pesanan yang sesuai sebagai sudah ter-packing, menyimpan barcode unik fisik (barcode_unique),
   * mengupdate status ke backend, serta menampilkan notifikasi feedback yang jelas tanpa error mentah "Belum ada data".
   *
   * @param {string} rawBarcode - Barcode mentah dari scanner keyboard, scanner kamera, atau input teks.
   * @returns {Promise<boolean>} True jika item berhasil ditandai packing, false jika tidak.
   * @sideEffects Memanggil API updateProductCode/updateStatusPacking, mengupdate Formik state items (termasuk barcode_unique), dan menampilkan toast.
   */
  const handleProcessPackingBarcode = async (rawBarcode) => {
    const clean = cleanBarcode(rawBarcode);
    if (!clean) return false;

    const currentItems = formPacking.current?.values?.items || initialValues?.items || [];
    if (!currentItems || currentItems.length === 0) {
      showToast("Tidak ada item dalam daftar packing", "warning");
      return false;
    }

    try {
      // 1. Coba cari sebagai ProductCode (unit fisik / serial QR code)
      let productCodeData = null;
      try {
        const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(clean);
        // Jika format UUID: cari via qr_code, jika teks/serial number: cari via ref
        let response = await api.productCode.index(
          isUuid ? { qr_code: clean, limit: 1 } : { ref: clean, limit: 1 }
        );
        let items = Array.isArray(response?.data)
          ? response.data
          : response?.data?.items || [];

        // Fallback jika UUID tapi disimpan di kolom ref
        if (items.length === 0 && isUuid) {
          try {
            const fallbackRes = await api.productCode.index({ ref: clean, limit: 1 });
            items = Array.isArray(fallbackRes?.data)
              ? fallbackRes.data
              : fallbackRes?.data?.items || [];
          } catch (e) {
            if (e?.response?.status !== 404) throw e;
          }
        }

        if (items.length > 0) {
          productCodeData = items[0];
        }
      } catch (err) {
        // Jika 404 ("Belum ada data"), abaikan di sini agar tidak memunculkan popup error mentah
        if (err?.response?.status !== 404) {
          console.error("[Packing Scan] Error saat mencari ProductCode:", err);
          throw err;
        }
      }

      // Skenario A: ProductCode ditemukan
      if (productCodeData) {
        if (productCodeData.status !== "warehouse") {
          const msg =
            productCodeData.status === "packing"
              ? `Unit barcode "${clean}" sudah berstatus packing.`
              : `Unit barcode "${clean}" tidak berada di gudang (status: ${productCodeData.status}).`;
          showToast(msg, "error");
          return false;
        }

        let productVariant = productCodeData.product_variant;
        if (
          (!productVariant ||
            productVariant.size_variant_id === undefined ||
            productVariant.color_variant_id === undefined) &&
          productCodeData.product_variant_id
        ) {
          try {
            const varRes = await api.productVariant.show(productCodeData.product_variant_id);
            const varData = varRes?.data?.data || varRes?.data;
            if (varData) {
              productVariant = varData;
            }
          } catch (err) {
            console.warn("[Packing Scan] Gagal memuat detail varian:", err);
          }
        }

        const productId = productVariant?.product_id;
        const sizeVariantId = productVariant?.size_variant_id;
        const colorVariantId = productVariant?.color_variant_id;

        const updatedItems = currentItems.map((item) => ({ ...item }));
        let matchedIndex = -1;

        for (let i = 0; i < updatedItems.length; i++) {
          const el = updatedItems[i];
          const isProductMatch = Number(el?.product_id) === Number(productId);
          const isSizeMatch =
            (!el?.size_variant_id && !sizeVariantId) ||
            Number(el?.size_variant_id) === Number(sizeVariantId);
          const isColorMatch =
            (!el?.color_variant_id && !colorVariantId) ||
            Number(el?.color_variant_id) === Number(colorVariantId);

          if (
            isProductMatch &&
            isSizeMatch &&
            isColorMatch &&
            !el?.status_packing &&
            !el?.product_code_id &&
            !updatedItems.some((item) => item.product_code_id === productCodeData.id)
          ) {
            matchedIndex = i;
            break;
          }
        }

        if (matchedIndex === -1) {
          const alreadyInThisOrder = updatedItems.some(
            (item) => item.product_code_id === productCodeData.id
          );
          if (alreadyInThisOrder) {
            showToast(`Unit barcode "${clean}" sudah terpasang di daftar packing ini.`, "warning");
          } else {
            showToast(`Produk untuk barcode "${clean}" tidak ditemukan di daftar pesanan ini atau sudah lengkap.`, "error");
          }
          return false;
        }

        const isSuccess = await updateProductCode({
          id: productCodeData.id,
          status_packing: true,
          scan_packing_date: new Date(),
          sales_order_id: updatedItems[matchedIndex]?.sales_order_id,
          sales_channel_id:
            payloads?.SalesOrder?.sales_channel_id ||
            updatedItems[matchedIndex]?.sales_channel_id,
        });

        if (isSuccess) {
          updatedItems[matchedIndex].status_packing = true;
          updatedItems[matchedIndex].product_code_id = productCodeData.id;
          updatedItems[matchedIndex].barcode_unique =
            productCodeData.qr_code || productCodeData.ref || clean;
          updatedItems[matchedIndex].sales_channel_id =
            payloads?.SalesOrder?.sales_channel_id;

          if (formPacking.current) {
            formPacking.current.setFieldValue("items", updatedItems);
          }
          setInitialValues((prev) => ({ ...prev, items: updatedItems }));
          checkAllItemPacked(updatedItems);
          showToast(
            `Unit ${updatedItems[matchedIndex].product_name || "produk"} berhasil di-pack`,
            "success"
          );
          return true;
        }

        return false;
      }

      // Skenario B: ProductCode tidak ditemukan. Cek apakah ini barcode ProductVariant / SKU
      let variant = null;
      try {
        const varRes = await api.productVariant.index({
          qr_code: clean,
          limit: 1,
        });
        const varItems = Array.isArray(varRes?.data)
          ? varRes.data
          : varRes?.data?.items || [];
        if (varItems.length > 0) {
          variant = varItems[0];
        }
      } catch (err) {
        if (err?.response?.status !== 404) throw err;
      }

      let productSku = null;
      if (!variant) {
        try {
          const prodRes = await api.product.index({
            code: clean,
            limit: 1,
          });
          const prodItems = Array.isArray(prodRes?.data)
            ? prodRes.data
            : prodRes?.data?.items || [];
          if (prodItems.length > 0) {
            productSku = prodItems[0];
          }
        } catch (err) {
          if (err?.response?.status !== 404) throw err;
        }
      }

      if (variant || productSku) {
        const pId = variant?.product_id || productSku?.id;
        const sId = variant?.size_variant_id;
        const cId = variant?.color_variant_id;

        const updatedItems = currentItems.map((item) => ({ ...item }));
        const nonUniqueIndex = updatedItems.findIndex(
          (el) =>
            el?.product_id === pId &&
            (!sId || el?.size_variant_id === sId) &&
            (!cId || el?.color_variant_id === cId) &&
            el?.is_unique_barcode === false &&
            !el?.status_packing
        );

        if (nonUniqueIndex !== -1) {
          const targetItem = updatedItems[nonUniqueIndex];
          const status = await updateStatusPacking(
            { target: { checked: true } },
            targetItem.id
          );
          if (status) {
            updatedItems[nonUniqueIndex].status_packing = true;
            if (formPacking.current) {
              formPacking.current.setFieldValue("items", updatedItems);
            }
            setInitialValues((prev) => ({ ...prev, items: updatedItems }));
            checkAllItemPacked(updatedItems);
            showToast(`Item ${targetItem.product_name || "produk"} berhasil di-pack`, "success");
            return true;
          }
        }

        const hasUniqueItemInOrder = updatedItems.some(
          (el) =>
            el?.product_id === pId &&
            (!sId || el?.size_variant_id === sId) &&
            (!cId || el?.color_variant_id === cId) &&
            el?.is_unique_barcode !== false
        );

        if (hasUniqueItemInOrder) {
          showToast(
            `Produk ini adalah produk unit unik. Harap scan QR Code unit fisik (Product Code), bukan QR Code varian.`,
            "warning",
            4000
          );
          return false;
        }

        showToast(`Produk untuk barcode "${clean}" tidak ada di daftar pesanan ini atau sudah lengkap.`, "error");
        return false;
      }

      // Skenario C: Barcode sama sekali tidak terdaftar
      showToast(`Barcode "${clean}" tidak terdaftar di sistem.`, "error");
      return false;
    } catch (error) {
      console.error("[Packing Scan] Error:", error);
      showToast(`Terjadi kesalahan saat memproses barcode "${clean}"`, "error");
      return false;
    }
  };

  /**
   * Menjadwalkan pemrosesan barcode ke dalam antrean asinkron (FIFO queue)
   * untuk mencegah race condition / saling timpa state saat pemindaian beruntun cepat (rapid scanning).
   *
   * @param {string} rawBarcode - Nilai barcode mentah yang akan diproses.
   * @returns {Promise<boolean>} Promise yang me-resolve hasil pemrosesan barcode.
   * @sideEffects Memperbarui scanQueueRef dan menjalankan handleProcessPackingBarcode secara sekuensial.
   */
  const enqueueBarcodeScan = (rawBarcode) => {
    scanQueueRef.current = scanQueueRef.current
      .then(() => handleProcessPackingBarcode(rawBarcode))
      .catch((err) => {
        console.error("[Packing Scan Queue] Error:", err);
        return false;
      });
    return scanQueueRef.current;
  };

  /**
   * Mengambil data unit ProductCode dan varian produk berdasarkan barcode secara aman tanpa error 404 mentah.
   *
   * @param {string} value - String barcode yang dipindai.
   * @returns {Promise<Object|null>} Objek informasi produk { product_id, size_variant_id, color_variant_id, product_code_id } atau null jika tidak valid.
   * @sideEffects Memanggil API productCode dan productVariant backend.
   */
  const setItemOrder = useCallback(async (value) => {
    const clean = cleanBarcode(value);
    if (!clean) return null;

    try {
      let productCodeData = null;
      try {
        const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(clean);
        let response = await api.productCode.index(
          isUuid ? { qr_code: clean, limit: 1 } : { ref: clean, limit: 1 }
        );
        let items = Array.isArray(response?.data)
          ? response.data
          : response?.data?.items || [];

        if (items.length === 0 && isUuid) {
          try {
            const fallbackRes = await api.productCode.index({ ref: clean, limit: 1 });
            items = Array.isArray(fallbackRes?.data)
              ? fallbackRes.data
              : fallbackRes?.data?.items || [];
          } catch (e) {
            // Abaikan fallback error
          }
        }

        if (items.length > 0) {
          productCodeData = items[0];
        }
      } catch (err) {
        if (err?.response?.status !== 404) {
          console.warn("[setItemOrder] Gagal mencari productCode:", err);
        }
      }

      if (!productCodeData || productCodeData.status !== "warehouse") {
        const msg = productCodeData
          ? `Unit barcode "${clean}" tidak berstatus di gudang (status: ${productCodeData.status}).`
          : `Unit barcode "${clean}" tidak ditemukan di sistem.`;
        showToast(msg, "error");
        return null;
      }

      let productVariant = productCodeData.product_variant;
      if (
        (!productVariant ||
          productVariant.size_variant_id === undefined ||
          productVariant.color_variant_id === undefined) &&
        productCodeData.product_variant_id
      ) {
        try {
          const responseVariant = await api.productVariant.show(productCodeData.product_variant_id);
          const varData = responseVariant?.data?.data || responseVariant?.data;
          if (varData) {
            productVariant = varData;
          }
        } catch (err) {
          console.warn("[setItemOrder] Gagal mengambil varian:", err);
        }
      }

      if (!productVariant) {
        showToast(`Varian produk tidak ditemukan untuk barcode: ${clean}`, "error");
        return null;
      }

      return {
        product_id: productVariant.product_id,
        size_variant_id: productVariant.size_variant_id,
        color_variant_id: productVariant.color_variant_id,
        product_code_id: productCodeData.id,
      };
    } catch (err) {
      console.error("[setItemOrder] Error:", err);
      showToast(`Terjadi kesalahan saat memeriksa barcode "${clean}"`, "error");
      return null;
    }
  }, [showToast]);

  /**
   * Menangani event pengetikan barcode pada input form secara manual saat menekan Enter.
   *
   * @param {React.KeyboardEvent} e - Keyboard event dari elemen input.
   * @sideEffects Memanggil handleProcessPackingBarcode dan mengosongkan nilai input.
   */
  const handleScanBarcodeChange = async (e) => {
    if (scanBarcodeInputRef.current) {
      scanBarcodeInputRef.current.focus();
    }

    const value = e.target?.value;
    if (e.key === "Enter" && typeof value === "string" && value.trim() !== "") {
      e.preventDefault();
      await enqueueBarcodeScan(value);
      setQrCode("");
    }
  };  // Add dependencies array

  console.log("payloads", payloads);
  useEffect(() => {
    const initItems = async () => {
      let productCodeList = payloads?.product_code;

      // Fallback: Jika payloads tidak memiliki product_code tapi memiliki sales_order_id, muat langsung dari API
      if ((!productCodeList || productCodeList.length === 0) && payloads?.sales_order_id) {
        try {
          const response = await api.productCode.index({
            sales_order_id: payloads.sales_order_id,
          });
          const rawCodes = Array.isArray(response?.data)
            ? response.data
            : response?.data?.items || [];

          if (rawCodes.length > 0) {
            productCodeList = await Promise.all(
              rawCodes.map(async (item) => {
                if (item?.product_variant) return item;
                try {
                  const variantRes = await api.productVariant.index({
                    id: item?.product_variant_id,
                    limit: 1,
                  });
                  const varItem = Array.isArray(variantRes?.data)
                    ? variantRes.data[0]
                    : variantRes?.data?.items?.[0] || null;
                  return { ...item, product_variant: varItem };
                } catch {
                  return item;
                }
              })
            );
          }
        } catch (err) {
          console.warn("[Packing Modal] Gagal memuat fallback productCode:", err);
        }
      }

      // Pastikan varian pada setiap unit ProductCode terisi untuk pencocokan
      if (Array.isArray(productCodeList) && productCodeList.length > 0) {
        const needsEnrich = productCodeList.some(
          (pc) => !pc?.product_variant && pc?.product_variant_id
        );
        if (needsEnrich) {
          productCodeList = await Promise.all(
            productCodeList.map(async (pc) => {
              if (pc?.product_variant) return pc;
              if (!pc?.product_variant_id) return pc;
              try {
                const variantRes = await api.productVariant.index({
                  id: pc.product_variant_id,
                  limit: 1,
                });
                const varItem = Array.isArray(variantRes?.data)
                  ? variantRes.data[0]
                  : variantRes?.data?.items?.[0] || null;
                return { ...pc, product_variant: varItem };
              } catch {
                return pc;
              }
            })
          );
        }
      }

      const mappedItems =
        payloads?.OrderItems?.flatMap((item) => {
          // Non-unique products never get a ProductCode row
          if (item?.master_product?.is_unique_barcode === false) {
            return [
              {
                id: item?.id,
                product_name: item?.master_product?.name,
                imageUrl: item?.master_product?.imageUrl,
                code: item?.master_product?.code,
                size: item?.master_size?.name,
                color: item?.master_color?.name,
                qty: item?.qty,
                product_id: item?.product_id,
                color_variant_id: item?.color_variant_id,
                size_variant_id: item?.size_variant_id,
                sales_order_id: payloads?.sales_order_id,
                sales_channel_id: payloads?.sales_channel_id,
                status_packing: item?.status_packing ?? false,
                is_unique_barcode: false,
              },
            ];
          }

          // Pencocokan toleran antara product_variant pada ProductCode dan OrderItem
          const productCodesForItem = (productCodeList || []).filter((pc) => {
            const isProdMatch =
              Number(pc?.product_variant?.product_id) === Number(item?.product_id);
            const isSizeMatch =
              (!pc?.product_variant?.size_variant_id && !item?.size_variant_id) ||
              Number(pc?.product_variant?.size_variant_id) ===
              Number(item?.size_variant_id);
            const isColorMatch =
              (!pc?.product_variant?.color_variant_id && !item?.color_variant_id) ||
              Number(pc?.product_variant?.color_variant_id) ===
              Number(item?.color_variant_id);
            return isProdMatch && isSizeMatch && isColorMatch;
          });

          // Use the length of product codes or item quantity, whichever is smaller
          const processLength = Math.min(
            productCodesForItem?.length || 0,
            item?.qty || 0
          );

          return Array.from({ length: processLength }, (_, index) => ({
            id: item?.id,
            product_name: item?.master_product?.name,
            imageUrl: item?.master_product?.imageUrl,
            code: item?.master_product?.code,
            size: item?.master_size?.name,
            color: item?.master_color?.name,
            qty: 1,
            product_id: item?.product_id,
            color_variant_id: item?.color_variant_id,
            size_variant_id: item?.size_variant_id,
            sales_order_id: payloads?.sales_order_id,
            sales_channel_id: payloads?.sales_channel_id,
            status_packing: true,
            product_code_id: productCodesForItem[index]?.id,
            barcode_unique:
              productCodesForItem[index]?.qr_code ||
              productCodesForItem[index]?.ref ||
              null,
            is_unique_barcode: true,
          })).concat(
            // Add remaining items without product code
            Array.from({ length: (item?.qty || 0) - processLength }, () => ({
              id: item?.id,
              product_name: item?.master_product?.name,
              imageUrl: item?.master_product?.imageUrl,
              code: item?.master_product?.code,
              size: item?.master_size?.name,
              color: item?.master_color?.name,
              qty: 1,
              product_id: item?.product_id,
              color_variant_id: item?.color_variant_id,
              size_variant_id: item?.size_variant_id,
              sales_order_id: payloads?.sales_order_id,
              sales_channel_id: payloads?.sales_channel_id,
              status_packing: false,
              product_code_id: null,
              barcode_unique: null,
              is_unique_barcode: true,
            }))
          );
        }) || [];

      setInitialValues((prev) => ({
        ...prev,
        id: payloads.id,
        code: payloads.code,
        packing_picture: payloads?.packing_picture,
        image_date: payloads?.image_date,
        resi_number: payloads?.resi_number,
        status: payloads.status == 2 ? 3 : 4,
        items: mappedItems,
      }));

      if (formPacking.current) {
        formPacking.current.setFieldValue("items", mappedItems);
      }
    };

    initItems();
    setQrCode("");
  }, [payloads]);

  /**
   * Menangani pemindaian barcode hardware global saat modal Packing Order aktif.
   * Memproses barcode unit atau varian dan menandai item ke daftar packing menggunakan handleProcessPackingBarcode.
   *
   * @param {string} scannedBarcode - Nilai barcode yang telah dibersihkan oleh scanner buffer.
   * @sideEffects Memanggil handleProcessPackingBarcode dan mengosongkan state qrCode.
   */
  useBarcodeScanner(async (scannedBarcode) => {
    await enqueueBarcodeScan(scannedBarcode);
    setQrCode("");
  }, { info: "Packing Order" });

  const handleModalClick = () => {
    if (scanBarcodeInputRef.current) {
      scanBarcodeInputRef.current.focus();
    }
  };

  // Add these functions before the return statement
  const startCamera = async () => {
    try {
      setCameraMode(true);
      setCameraError(null);
      setCapturedImage(null);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        },
        audio: false
      });

      setCameraStream(stream);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Error accessing camera:", err);
      setCameraError("Tidak dapat mengakses kamera. Pastikan Anda telah memberikan izin akses kamera.");
      setCameraMode(false);
    }
  };

  const stopCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
      setCameraStream(null);
    }
    setCameraMode(false);
    setPhotoUsed(false);
    setCameraError(null);
  };

  const capturePhoto = async () => {
    if (videoRef.current) {
      const video = videoRef.current;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas to blob
      const blob = await new Promise(resolve => {
        canvas.toBlob(resolve, 'image/jpeg', 0.9);
      });

      // Create URL for preview
      const imageUrl = URL.createObjectURL(blob);
      setCapturedImage(imageUrl);

      // Stop the camera stream
      stopCamera();
    }
  };

  const dataURLtoFile = (dataurl, filename) => {
    // If it's already a blob URL (from URL.createObjectURL)
    if (dataurl.startsWith('blob:')) {
      return fetch(dataurl)
        .then(res => res.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
    }

    // If it's a data URL
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleAcceptPhoto = async () => {
    try {
      const file = await dataURLtoFile(capturedImage, `packing-${new Date().getTime()}.jpg`);
      // Don't close camera mode or clear captured image
      await fileChangeHandler({ target: { files: [file] } });
      setPhotoUsed(true);
    } catch (error) {
      console.error("Error processing image:", error);
      setCameraError("Gagal memproses foto. Silakan coba lagi.");
    }
  };

  useEffect(() => {
    return () => {
      if (uploadedImage) {
        URL.revokeObjectURL(uploadedImage);
      }
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => track.stop());
      }
    };
  }, [uploadedImage, cameraStream]);

  return (
    <ModalMolecule
      show={showStates["deliveryOrder.packing"]}
      title="Packing Pengiriman"
      onClose={handleClose}
    >
      {isLoading && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-200 bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded-md">
            <p>Loading...</p>
          </div>
        </div>
      )}
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
        innerRef={formPacking}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form
            className="space-y-4"
            onSubmit={handleSubmit}
            onClick={handleModalClick}
          >
            <div>{values.code}</div>
            {showQrScanner ? (
              <div className="mb-4">
                <div id="html5-qr-code-scanner" className="qr-scanner-container"></div>
                <div className="text-center text-sm text-gray-500 mt-2">
                  Point your camera at a QR code to scan
                </div>
                <div className="text-center mt-4">
                  <button data-testid="modal-create-packing-order-cancel-button"
                    type="button"
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                    onClick={() => setShowQrScanner(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div className="relative">
                <input data-testid="modal-create-packing-order-scan-barcode-input"
                  className="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-gray-900 placeholder-gray-300 shadow-sm focus:border-primary-600 focus:outline-none disabled:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder-gray-500 autofill:dark:bg-gray-800 dark:disabled:bg-gray-800 focus:ring-1 focus:ring-primary-600 pr-10"
                  type="text"
                  name="scan_barcode"
                  placeholder="Scan QR Code"
                  onChange={(e) => {
                    setQrCode(e.target.value);
                    handleScanBarcodeChange(e, { setFieldValue, values });
                  }}
                  onKeyDown={(e) => {
                    // Trigger scanning on Enter key
                    if (e.key === "Enter") {
                      handleScanBarcodeChange(e, { setFieldValue, values });
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                  }}
                  value={qrCode}
                  ref={scanBarcodeInputRef}
                  autoFocus
                  onFocus={(e) => {
                    e.target.select();
                    e.target.focus();
                  }}
                  onClick={(e) => {
                    e.target.select();
                    e.target.focus();
                  }}
                />
                <div
                  className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={() => setShowQrScanner(true)}
                  title="Scan with camera"
                >
                  <CameraIcon className="h-5 w-5" />
                </div>
              </div>
            )}
            <Table.Container>
              <Table.Wrapper asIndex={false}>
                <Table.Header>
                  <Table.HeaderRow>
                    <Table.Heading>Produk</Table.Heading>
                    <Table.Heading>Varian</Table.Heading>
                    <Table.Heading align="right">Qty</Table.Heading>
                    <Table.Heading align="right">Status</Table.Heading>
                    <Table.Heading align="right"></Table.Heading>
                  </Table.HeaderRow>
                </Table.Header>
                <Table.Body>
                  {values?.items
                    ?.sort((a, b) => a.id - b.id)
                    .map((item, index) => (
                      <Table.BodyRow key={index}>
                        <Table.Cell>
                          <div className="flex gap-2 items-center">
                            {item?.imageUrl && item?.imageUrl != "" ? (
                              <ImageWithPreview
                                size="lg"
                                src={`${process.env.REACT_APP_AWS_LINK_URL}${item?.imageUrl}`}
                              ></ImageWithPreview>
                            ) : null}
                            <div>
                              <div>{item?.product_name}</div>
                              <div className="text-xs text-gray-500">{item?.code}</div>
                              {item?.status_packing && item?.barcode_unique && (
                                <div className="mt-1" title={`Barcode Fisik: ${item?.barcode_unique}`}>
                                  <Badge color="blue" size="xs">
                                    <span className="font-mono"> {item?.barcode_unique}</span>
                                  </Badge>
                                </div>
                              )}
                            </div>
                          </div>
                        </Table.Cell>
                        <Table.Cell>
                          <div className="flex flex-wrap gap-2 items-center">
                            <Badge color="gray">{item?.size}</Badge>
                            <Badge color="gray">{item?.color}</Badge>
                          </div>
                        </Table.Cell>
                        <Table.Cell align="right">{item?.qty}</Table.Cell>
                        <Table.Cell>
                          <div style={{ textAlign: 'center' }}>
                            <Badge color={item?.status_packing ? "green" : "gray"}>
                              {item?.status_packing ? "Sudah Packing" : "Belum Packing"}
                            </Badge>
                            {!item?.status_packing && (
                              <div>
                                <ErrorMessage>{getIn(errors, `items.${index}.status_packing`)}</ErrorMessage>
                              </div>
                            )}
                          </div>
                        </Table.Cell>
                        <Table.Cell align="right">
                          <input data-testid="modal-create-packing-order-items-status-packing-input"
                            type="checkbox"
                            checked={item?.status_packing ? true : false}
                            name={`items.${index}.status_packing`}
                            // Non-unique lines have no ProductCode to scan, so their
                            // checkbox is a plain manual toggle (both directions).
                            // Unique lines are untouched: checking still requires a
                            // scan, this box can only ever uncheck.
                            disabled={item?.is_unique_barcode === false ? false : !item?.status_packing}
                            onChange={async (e) => {
                              if (item?.is_unique_barcode === false) {
                                const checked = e.target.checked;
                                const status = await updateStatusPacking(e, item?.id);
                                if (status) {
                                  values.items[index].status_packing = checked;
                                  setInitialValues({
                                    ...initialValues,
                                    items: values.items,
                                  });
                                }
                                return;
                              }
                              cancelPacking(item?.id, { setFieldValue, values });
                            }}
                          />
                        </Table.Cell>
                      </Table.BodyRow>
                    ))}
                </Table.Body>
              </Table.Wrapper>
            </Table.Container>
            {/* Update the file upload section with this new JSX */}
            {payloads.status == 2 && (
              <div className="space-y-4">
                {!cameraMode && !capturedImage ? (
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Upload foto hasil packing
                      </label>
                      <button data-testid="modal-create-packing-order-camera-button"
                        type="button"
                        onClick={startCamera}
                        className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                      >
                        <CameraIcon className="-ml-0.5 mr-2 h-4 w-4" />
                        Ambil Foto
                      </button>
                    </div>

                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                      {uploadedImage ? (
                        <div className="relative w-full">
                          <img
                            src={uploadedImage}
                            alt="Uploaded preview"
                            className="w-full h-auto max-h-60 object-contain"
                          />
                          <button data-testid="modal-create-packing-order-x-mark-button"
                            type="button"
                            onClick={() => {
                              setUploadedImage(null);
                              // Clear the file input
                              const fileInput = document.getElementById('file-upload');
                              if (fileInput) fileInput.value = '';
                            }}
                            className="absolute top-2 right-2 p-1 bg-black bg-opacity-50 rounded-full text-white hover:bg-opacity-70"
                            title="Hapus gambar"
                          >
                            <XMarkIcon className="h-5 w-5" />
                          </button>
                        </div>
                      ) : (
                        <div className="space-y-1 text-center">
                          <PhotoIcon className="mx-auto h-12 w-12 text-gray-400" />
                          <div className="flex text-sm text-gray-600">
                            <label
                              htmlFor="file-upload"
                              className="relative cursor-pointer bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                            >
                              <span>Upload file</span>
                              <input data-testid="modal-create-packing-order-file-upload-input"
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                className="sr-only"
                                onChange={fileChangeHandler}
                                accept="image/*"
                              />
                            </label>
                            <p className="pl-1">atau drag and drop</p>
                          </div>
                          <p className="text-xs text-gray-500">PNG, JPG, JPEG (maks. 10MB)</p>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div className="relative bg-black rounded-lg">
                      {capturedImage ? (
                        <div className="relative">
                          <img
                            src={capturedImage}
                            alt="Captured"
                            className="w-full h-auto max-h-[60vh] object-contain"
                          />
                          <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-4">
                            {!photoUsed && (
                              <button data-testid="modal-create-packing-order-check-button"
                                type="button"
                                onClick={handleAcceptPhoto}
                                className="p-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors shadow-lg"
                                title="Gunakan foto ini"
                              >
                                <CheckIcon className="h-6 w-6" />
                              </button>
                            )}
                            <button data-testid="modal-create-packing-order-arrow-path-button"
                              type="button"
                              onClick={() => {
                                setCapturedImage(null);
                                startCamera();
                                setPhotoUsed(false);
                              }}
                              className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors shadow-lg"
                              title="Ambil ulang"
                            >
                              <ArrowPathIcon className="h-6 w-6" />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            className="w-full h-auto max-h-[60vh] object-contain"
                          />
                          <div className="absolute top-2 right-2">
                            <button data-testid="modal-create-packing-order-x-mark-button"
                              type="button"
                              onClick={() => {
                                stopCamera();
                                setCameraMode(false);
                              }}
                              className="p-2 bg-black bg-opacity-50 rounded-full text-white hover:bg-opacity-70 focus:outline-none"
                            >
                              <XMarkIcon className="h-6 w-6" />
                            </button>
                          </div>
                        </>
                      )}
                    </div>

                    {!capturedImage && (
                      <div className="flex justify-center">
                        <button data-testid="modal-create-packing-order-camera-button"
                          type="button"
                          onClick={capturePhoto}
                          className="p-3 bg-white/90 rounded-full shadow-lg hover:bg-white transition-all transform hover:scale-105 focus:outline-none"
                        >
                          <div className="w-12 h-12 bg-red-500 rounded-full border-4 border-white ring-2 ring-red-300 flex items-center justify-center">
                            <CameraIcon className="h-6 w-6 text-white" />
                          </div>
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {cameraError && (
                  <p className="mt-2 text-sm text-red-600">{cameraError}</p>
                )}

                {errors.file && touched.file && (
                  <p className="mt-2 text-sm text-red-600">{errors.file}</p>
                )}
              </div>
            )}
            {payloads.status == 3 && (
              <>
                <div className="bg-dark-100 p-4 rounded-md border border-dark-200">
                  <InputMolecule testId="modal-create-packing-order-resi-number-input"
                    label="Nomor Resi Pengiriman"
                    type="text"
                    name="resi_number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.resi_number}
                    errorMessage={
                      errors.resi_number &&
                      touched.resi_number &&
                      errors.resi_number
                    }
                    placeholder="contoh: 11LP1680679892004"
                  />
                </div>
                <p>
                  Tanggal Foto:{" "}
                  <span className="text-danger-600">
                    {new Date(
                      payloads && Number(payloads.image_date)
                    ).toLocaleString()}
                  </span>
                </p>
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}file/${payloads?.packing_picture}`}
                />
              </>
            )}

            {payloads.status == 4 && (
              <div>
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}file/${payloads?.packing_picture}`}
                />

                <p>No. Resi: {values.resi_number}</p>
              </div>
            )}
            <div></div>
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-packing-order-submit-button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Menyimpan...' : (payloads.status == 3
                  ? "Konfirmasi Pengiriman"
                  : payloads.status == 4
                    ? "Selesai"
                    : "Konfirmasi Packing")}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule >
  );
}

export default CreateDeliveryPackingModal;
